import {
  GET_MEETINGS,
  GET_MEETINGS_SUCCESS,
  GET_MEETINGS_FAIL,
  ADD_MEETING,
  ADD_MEETING_SUCCESS,
  ADD_MEETING_FAIL,
  UPDATE_MEETING,
  UPDATE_MEETING_SUCCESS,
  UPDATE_MEETING_FAIL,
  DELETE_MEETING,
  DELETE_MEETING_SUCCESS,
  DELETE_MEETING_FAIL,
  SHOW_LOADING,
  HIDE_LOADING
} from './actionTypes';

// GET ALL MEETINGS
export const getMeetings = () => ({
  type: GET_MEETINGS
});
export const getMeetingsSuccess = (meetings) => ({
  type: GET_MEETINGS_SUCCESS,
  payload: meetings
});
export const getMeetingsFail = error => ({
  type: GET_MEETINGS_FAIL,
  payload: error,
})
// ADD NEW MEETING
export const addMeeting = (meeting) => ({
  type: ADD_MEETING,
  payload: meeting
});
export const addMeetingSuccess = meeting => ({
  type: ADD_MEETING_SUCCESS,
  payload: meeting,
})
export const addMeetingFail = error => ({
  type: ADD_MEETING_FAIL,
  payload: error,
})
// UPDATE MEETING
export const updateMeeting = (meeting) => ({
  type: UPDATE_MEETING,
  payload: meeting
});
export const updateMeetingSuccess = meeting => ({
  type: UPDATE_MEETING_SUCCESS,
  payload: meeting,
})
export const updateMeetingFail = error => ({
  type: UPDATE_MEETING_FAIL,
  payload: error,
})
// DELETE MEETING
export const deleteMeeting = (meeting) => ({
  type: DELETE_MEETING,
  payload: meeting
});
export const deleteMeetingSuccess = meeting => ({
  type: DELETE_MEETING_SUCCESS,
  payload: meeting,
})
export const deleteMeetingFail = error => ({
  type: DELETE_MEETING_FAIL,
  payload: error,
})

export const showLoading = (status) => ({
  type: SHOW_LOADING,
  payload: status
});

export const hideLoading = (status) => ({
  type: HIDE_LOADING,
  payload: status
});
